// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__rogan_bb3751', '__rogan_Fallback_bb3751'"},"className":"__className_bb3751"};